import React, {Component} from 'react'
import {connect} from 'react-redux'
import CopyURLSegment from "../../SharedComponents/CopyURLSegment";
import styles from "../../SQL/styles";
import AceEditor from 'react-ace';
import 'brace/theme/monokai';
import 'brace/mode/json';
import getURLParam from "../../Constants/getURLParam";
import {getQueryParamValue} from "../../Constants/getQueryParamValue";
import BannerAlert from "../../SharedComponents/BannerAlert";
import {isMobile} from "react-device-detect";
import { Button } from 'semantic-ui-react'
import {toggleToast} from "../../Actions/ToggleToast";
import API_Backend_Root from "../../Constants/API_Backend_Root";

class RunMacrosIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receiveInfo: false
        }
    }

    componentDidMount(){
        fetch(API_Backend_Root + "store-analytics-from-ui/", {
            method: "POST",
            body: JSON.stringify({"data": {"Email":localStorage.getItem("email"),
                    "Notes":"User clicked on Excel Macro tab","Use Case":"Excel Macros","Date Saved":(new Date()).toLocaleDateString(),"Usage Metrics":""},
                "headers": {"accessKey": "2863a49b9ea04e9847cb90f0e0aa93d5", "secretKey": "9eca419e34ff1e929f05d00598dfb679"},
                "apiUrl": "https://api.apispreadsheets.com/data/Zh4Ob0LXhmZN3goL/", "sendEmailAlert": true}),
        }).then(res =>{
            if (res.status === 201){
                console.log("lead saved")
            }
            else{
                console.log("lead not saved")
            }
        }).catch(err => console.log(err))
    }

    receiveInformation = () => {
        this.setState({
            receiveInfo: true
        })

        const finalMessage = () => {
            this.setState({
                receiveInfo: false
            }, () => this.props.toggleToast({show: true, message: "Thank you for your interest. We will be reaching out with next steps shortly!", type: "success"}))
        }

        fetch(API_Backend_Root + "store-analytics-from-ui/", {
            method: "POST",
            body: JSON.stringify({"data": {"Email":localStorage.getItem("email"),
                    "Notes":"User clicked Receive Information button on Excel Macro tab","Use Case":"Excel Macros","Date Saved":(new Date()).toLocaleDateString(),"Usage Metrics":""},
                "headers": {"accessKey":"2863a49b9ea04e9847cb90f0e0aa93d5", "secretKey":"9eca419e34ff1e929f05d00598dfb679"},
                "apiUrl": "https://api.apispreadsheets.com/data/Zh4Ob0LXhmZN3goL/", "sendEmailAlert": true})
        }).then(res =>{
            finalMessage()
        }).catch(err => finalMessage())

    }

    render() {
        let url = this.props.getURL.replace("/data/", "/run-macro/");
        let jsonparams = '{\n\t"accessKey":"' + getQueryParamValue("accessKey", url) + '",'+
            '\n\t"secretKey":"' + getQueryParamValue("secretKey", url) + '",' +
            '\n\t"macro_name":"TestGetPremium",' +
            '\n\t"macro_parameters":["M", 120000, 25, 30],' +
            '\n\t"output_cells":["C8", "C9"]' +
             '\n}'

        if (url.includes("?")){
            url = url.substring(0, url.indexOf("?"))
        }

        return (
            <div>
                <div style={{ marginTop: "12px"}}>
                    <BannerAlert
                        type="warning"
                        header='This feature is an ENTERPRISE add-on to the base API plans'
                        icon="bx bxs-error"
                        content="Click the receive information button to get this set up for your account"
                        action={<Button loading={this.state.receiveInfo} color='orange' content='Receive Information' onClick={this.receiveInformation} />}
                    />
                </div>
                <CopyURLSegment
                    url={url}
                    disabled
                    header={<span>API URL to Run Macros & Formulas
                        <span style={{ backgroundColor: "orange", color: "white", fontSize: "85%", padding: "0 4px 0 4px", fontWeight: "700", marginLeft: "6px"}}>
                            POST
                        </span></span>}
                />
                <br/>
                <div style={{ fontSize: "16px", color: styles.mainText, fontWeight: "700"}}>
                    Request Body Parameters
                </div>
                <div style={{ fontSize: "12px"}} className="filesIDDisplayBox">
                    <code>macro_parameters</code> and <code>output_cells</code> are not required below
                </div>
                <AceEditor
                    mode="json"
                    theme="monokai"
                    value={jsonparams}
                    name="UNIQUE_ID_OF_DIV"
                    editorProps={{$blockScrolling: true}}
                    height="500px"
                    width="auto"
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {
    toggleToast: toggleToast
}

export default connect(mapStateToProps, mapActionsToProps)(RunMacrosIndex)